'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('../utils/underscore');

var _reactUtils = require('react-utils');

var ComponentWithWindowListeners = {
  componentDidMount: function componentDidMount() {
    (0, _reactUtils.invariant)(typeof this.getWindowListeners === 'function', 'ComponentWithWindowListeners: component must define' + ' a getWindowListeners function.');

    this._windowListeners = this.getWindowListeners();
    if (this.shouldBindWindowListeners()) {
      this.bindWindowListeners();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.unbindWindowListeners();
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.shouldBindWindowListeners()) {
      this.bindWindowListeners();
    } else {
      this.unbindWindowListeners();
    }
  },
  bindWindowListeners: function bindWindowListeners() {
    if (this._windowListenersBound) {
      return;
    }

    (0, _underscore.each)(this._windowListeners, function (handler, eventName) {
      (0, _reactUtils.invariant)(typeof handler === 'function', 'ComponentWithWindowListeners: `%s` listener is not a function', eventName);
      window.addEventListener(eventName, handler);
    });
    this._windowListenersBound = true;
  },
  unbindWindowListeners: function unbindWindowListeners() {
    if (!this._windowListenersBound) {
      return;
    }

    (0, _underscore.each)(this._windowListeners, function (handler, eventName) {
      window.removeEventListener(eventName, handler);
    });
    this._windowListenersBound = false;
  },
  shouldBindWindowListeners: function shouldBindWindowListeners() {
    /* eslint-disable react/no-is-mounted */
    if (!this.isMounted()) {
      // It's apparently possible for componentDidUpdate() to be called after
      // componentWillUnmount(). See #2287
      return false;
    }
    var getWindowListenersActive = this.getWindowListenersActive;

    var hasActiveCondition = typeof getWindowListenersActive === 'function';
    return hasActiveCondition ? getWindowListenersActive() : true;
    /* eslint-enable react/no-is-mounted */
  }
};

exports.default = ComponentWithWindowListeners;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/mixins/ComponentWithWindowListeners.js
// module id = 89
// module chunks = 0 1